import { STORE_UI_PREFERENCES, UIPreferencesAction } from '@Actions/uiPreferencesAction';

import { IUIPreferencesModel } from '@Shared/models';

interface IUIPreferencesState {
  uiPreferences: IUIPreferencesModel;
}
export function uiPreferencesReducer(state: IUIPreferencesState = { uiPreferences: window.UI_PREFERENCES }, action: UIPreferencesAction) {
  switch (action.type) {
    case STORE_UI_PREFERENCES:
      return { ...state, uiPreferences: action.uiPreferences };
    default:
      return state;
  }
}
